export const getGladlySections = async () => {
  const response = await fetch("https://cdn.gladly.com/orgs/configs/help-center/diggs.com-en-us.json");
  const sections = await response.json();

  return sections?.sections;
}

export const getGladlyAnswersByType = async (object, type) => {
  const response = await fetch("https://diggs.us-1.gladly.com/api/v1/orgs/aKRyGPijTU2WWhsCUmdipw/answers", {
    lng: "en-us"
  });
  const anwsers = await response.json();

  const typeObject = {
    id: () => anwsers.filter(answer => object.includes(answer.id)),
    answer: () => anwsers.filter(answer => answer.name.toLowerCase().includes(object?.toLowerCase()) || answer.bodyHtml.toLowerCase().includes(object?.toLowerCase())),
  }

  return typeObject[type]();
}

export const setAnswersByQuery = (search, setAnswers, setSelectedSection) => {
  getGladlyAnswersByType(search.query, 'answer').then(res => setAnswers(res)).then(() => setSelectedSection(null));
}
